
/**
 * 계정 상태
 */
export type SearchUsers200ContentItemStatus = typeof SearchUsers200ContentItemStatus[keyof typeof SearchUsers200ContentItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchUsers200ContentItemStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  DELETED: 'DELETED',
} as const;
